import { Trans, useTranslation } from 'react-i18next';

import Form from './Form';
import Help from './Help';
import Payment from './Payment';

function Unsubscribe() {
	const { t } = useTranslation();
	return (
		<main className="relative flex flex-col items-center justify-center bg-grey-100 pb-10 pt-7 lg:pb-[140px] lg:pt-[80px]">
			<div className="mb-8 lg:mb-10 lg:text-center">
				<div className="container flex flex-col gap-3 lg:gap-5">
					<h1 className="font-title text-[32px] font-semibold leading-10 lg:text-[56px] lg:font-bold lg:leading-[64px]">
						{t('unsubscribe.main.title')}
					</h1>
					<h2 className="max-w-[814px] text-sm leading-[24px] lg:text-base">
						<Trans
							t={t}
							i18nKey="unsubscribe.main.subtitle"
							components={{
								strong: <strong className="font-semibold" />
							}}
						/>
					</h2>
				</div>
			</div>

			<div className="container relative flex flex-col gap-12 lg:gap-[140px]">
				<div className="absolute left-0 right-0 top-[70rem] z-0 mx-auto hidden h-72 w-72 rounded-full bg-red blur-[142px] lg:block" />
				<Form />
				<Payment />
				<Help />
			</div>
		</main>
	);
}
export default Unsubscribe;
